import Button from '@Components/Buttons/Button'
import { ICONS } from '@Const/common'
import React, { useContext } from 'react'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'

interface WizardSubmitButtonProps {
    buttonText?: string
    onSubmitButtonPressed: () => void
    disabled?: boolean
}

const WizardSubmitButton = (props: WizardSubmitButtonProps) => {
    const { buttonText = 'Submit', onSubmitButtonPressed, disabled = false } = props
    const { wizardFlowStore } = useContext<RootStore>(StoresContext)

    return (
        <div className="submit-nav-button">
            <Button
                mainColor
                type="primary"
                icon={ICONS.arrow_forward}
                disabled={disabled}
                onClick={async () => {
                    const validation = wizardFlowStore.currentFlowStep.onNextValidation
                        ? wizardFlowStore.currentFlowStep.onNextValidation()
                        : true

                    const isStepValid = validation instanceof Promise ? await validation : validation

                    if (isStepValid) {
                        onSubmitButtonPressed()
                    }
                }}
            >
                {buttonText}
            </Button>
        </div>
    )
}

export default WizardSubmitButton
